export default __webpack_public_path__ + "static/3-204c445c63bb58922d0a42a61d41f11f.jpeg";